import axios from 'axios'
import tokenManager from '@/commons/utils/token'
import environment from '@/commons/utils/environment'
import { filterPilihProdiAPI, getCookie } from "@/commons/utils/filterPilihProdiAPI";
  
const verifyAlumni = (data = {}) => {
  const { getToken } = tokenManager();
  const token = getToken();
  const programStudiId = getCookie("selectedProdi");

  const apiUrl = filterPilihProdiAPI("/call/alumni", {
    apiWithFilter: "verify/filter",
    defaultAPI: "verify",
  });

  const body = {
    ...data,
	programStudiId: programStudiId,
  };
	
	return axios.post(apiUrl, body,
	{
		params: { token },
		
		headers: {
			'Authorization': token,
			
		}
	})} 

export default verifyAlumni
